'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('pushtoken', {
        url: '/pushtoken',
        template: '<pushtoken></pushtoken>'
    });
}



// WEBPACK FOOTER //
// ./client/app/pushtoken/pushtoken.routes.js